import { render } from "./ContentInfoCardList.vue?vue&type=template&id=2cc39264"
import script from "./ContentInfoCardList.vue?vue&type=script&lang=js"
export * from "./ContentInfoCardList.vue?vue&type=script&lang=js"

import "./ContentInfoCardList.vue?vue&type=style&index=0&id=2cc39264&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__